import React from "react";
import styles from "./styles.module.scss";
import { UIButton, UIText } from "../uIKit";
import Separator from "../separator";
import { TEXT_TAGS } from "src/utils/enums";
import { useIsMobile } from "src/hooks/useIsMobile";

type AddonProps = {
  title: string;
  body: string;
  buttonText: string;
  onSubmit: () => void;
};

const Addon: React.FC<AddonProps> = ({ title, body, buttonText, onSubmit }) => {
  const isMobile = useIsMobile();
  return (
    <div className={styles.addonContainer}>
      <UIText text={title} tag={TEXT_TAGS.H1} size={24} weight={500} style={styles.title} />
      <Separator className={styles.separator} />
      <div className={styles.bodyWrapper}>
        <div className={styles.mTop}>
          <UIText text={body} size={isMobile ?14:16} weight={400} style={styles.body} />
        </div>
        <div className={styles.mTop}>
          <UIButton
            title={buttonText}
            onSubmit={onSubmit}
            fullWidth={isMobile?true:false}
          />
        </div>
      </div>
    </div>
  );
};

export default Addon;
